module.exports = __webpack_public_path__ + "media/images/icon_notice-7db9629deb5936a54e37e770f39be83e.svg";